export default __webpack_public_path__ + "static/media/arrow-white.1415fc6a.svg";